<div class="profile__wrapper">
  <form [formGroup]="form" class="row">
    <fieldset [disabled]="!isEditable" class="form__fieldset">
      <div class="row">
        <div class="col-sm-3 photo">
          <div class="photo-wrapper">
            <app-image-uploader
              [isEditable]="isEditable"
              formControlName="file"
            ></app-image-uploader>
            <div class="content">
              <div>
                <label class="status-label">Status </label>
                <div class="content_status dropdown__value">
                  <p>{{ status }}</p>
                </div>
              </div>
              <div>
                <label
                  class="status-label"
                  appMarkAsterisk
                  [formGroup]="form"
                  [controlName]="'employmentForm'"
                  [touched]="form.get('employmentForm')!.touched"
                  >Employment Type
                </label>
                <div class="content_employment">
                  <app-dropdown
                    [items]="employmentFormItems"
                    [border]="'none'"
                    formControlName="employmentForm"
                    [isEditMode]="isEditable"
                  ></app-dropdown>
                  <app-error-field
                    [displayError]="
                      isFieldInvalid('employmentForm', form) &&
                      form.get('employmentForm')!.hasError('required')
                    "
                    [errorMessage]="'The field is required'"
                  ></app-error-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-9">
          <div class="row">
            <div class="col-sm-6">
              <div class="row mb-3 general__item">
                <label
                  class="col-sm-3"
                  appMarkAsterisk
                  [formGroup]="form"
                  [controlName]="'name'"
                  [touched]="form.get('name')!.touched"
                  >Name
                </label>
                <div class="col-sm-7 general_form_input">
                  <input
                    type="text"
                    class="input__basic"
                    placeholder=" "
                    formControlName="name"
                  />
                  <app-error-field
                    [displayError]="
                      isFieldInvalid('name', form) &&
                      form.get('name')!.hasError('required')
                    "
                    [errorMessage]="'The field is required'"
                  ></app-error-field>
                  <app-error-field
                    [displayError]="
                      isFieldInvalid('name', form) &&
                      form.get('name')!.hasError('forbiddenAphabet') &&
                      !form.get('name')!.hasError('whitespace')
                    "
                    [errorMessage]="'Latin symbols are recuired for this field'"
                  ></app-error-field>
                  <app-error-field
                    [displayError]="
                      isFieldInvalid('name', form) &&
                      form.get('name')!.hasError('whitespace') &&
                      !form.get('name')!.hasError('required')
                    "
                    [errorMessage]="'Please remove spaces'"
                  ></app-error-field>
                  <app-error-field
                    [displayError]="
                      form.get('name')!.hasError('maxlength') &&
                      !form.get('name')!.hasError('whitespace') &&
                      !form.get('name')!.hasError('forbiddenAphabet')
                    "
                    [errorMessage]="'Max field length = 20'"
                  ></app-error-field>
                </div>
              </div>
              <div class="row mb-3 general__item">
                <label
                  class="col-sm-3"
                  appMarkAsterisk
                  [formGroup]="form"
                  [controlName]="'surname'"
                  [touched]="form.get('surname')!.touched"
                  >Surname
                </label>
                <div class="col-sm-7 general_form_input">
                  <input
                    type="text"
                    class="input__basic"
                    placeholder=" "
                    formControlName="surname"
                  />
                  <app-error-field
                    [displayError]="
                      isFieldInvalid('surname', form) &&
                      form.get('surname')!.hasError('required')
                    "
                    [errorMessage]="'The field is required'"
                  ></app-error-field>
                  <app-error-field
                    [displayError]="
                      isFieldInvalid('surname', form) &&
                      form.get('surname')!.hasError('forbiddenAphabet') &&
                      !form.get('surname')!.hasError('whitespace')
                    "
                    [errorMessage]="'Latin symbols are recuired for this field'"
                  ></app-error-field>
                  <app-error-field
                    [displayError]="
                      isFieldInvalid('surname', form) &&
                      form.get('surname')!.hasError('whitespace') &&
                      !form.get('surname')!.hasError('required')
                    "
                    [errorMessage]="'Please remove spaces'"
                  ></app-error-field>
                  <app-error-field
                    [displayError]="
                      form.get('surname')!.hasError('maxlength') &&
                      !form.get('surname')!.hasError('whitespace') &&
                      !form.get('surname')!.hasError('forbiddenAphabet')
                    "
                    [errorMessage]="'Max field length = 20'"
                  ></app-error-field>
                  <app-error-field
                    [displayError]="
                      isExistEmployee &&
                      form.get('name')!.valid &&
                      form.get('surname')!.valid
                    "
                    [errorMessage]="
                      'Employee with such first and last names already exists'
                    "
                  ></app-error-field>
                </div>
              </div>
              <div class="row mb-3 general__item">
                <label
                  class="col-sm-3"
                  appMarkAsterisk
                  [formGroup]="form"
                  [controlName]="'startDate'"
                  [touched]="form.get('startDate')!.touched"
                  >Start date
                </label>
                <div class="col-sm-7 general_form_input">
                  <div
                    [class.custom-input-empty]="
                      isEditable && !form.get('startDate')?.value
                    "
                    [class.custom-input-filled]="
                      isEditable && form.get('startDate')?.value
                    "
                    class="pl-8"
                  >
                    <app-datepicker
                      [iconLeft]="true"
                      [fontSize]="14"
                      formControlName="startDate"
                    ></app-datepicker>
                  </div>
                  <app-error-field
                    [displayError]="
                      isFieldInvalid('startDate', form) &&
                      form.get('startDate')!.hasError('required')
                    "
                    [errorMessage]="'The field is required'"
                  ></app-error-field>
                </div>
              </div>
              <div class="row mb-3 general__item">
                <label
                  class="col-sm-3"
                  appMarkAsterisk
                  [formGroup]="form"
                  [controlName]="'department'"
                  [touched]="form.get('department')!.touched"
                  >Department
                </label>
                <div class="col-sm-7 general_form_input">
                  <div
                    [class.custom-input-empty]="
                      isEditable && !form.get('department')?.value
                    "
                    [class.custom-input-filled]="
                      isEditable && form.get('department')?.value
                    "
                  >
                    <app-dropdown
                      [border]="'none'"
                      [isMultiselect]="false"
                      [items]="departmentItems"
                      formControlName="department"
                      [isEditMode]="isEditable"
                    ></app-dropdown>
                  </div>
                  <app-error-field
                    [displayError]="
                      isFieldInvalid('department', form) &&
                      form.get('department')!.hasError('required')
                    "
                    [errorMessage]="'The field is required'"
                  ></app-error-field>
                </div>
              </div>
              <div
                class="row mb-3 general__item"
                *ngIf="isDepartmentSelected && isDepartmentDelivery"
              >
                <label
                  class="col-sm-3"
                  appMarkAsterisk
                  [formGroup]="form"
                  [controlName]="'subDepartment'"
                  [touched]="form.get('subDepartment')!.touched"
                  >Sub department</label
                >
                <div class="col-sm-7 general_form_input">
                  <div
                    [class.custom-input-empty]="
                      isEditable && !form.get('subDepartment')?.value
                    "
                    [class.custom-input-filled]="
                      isEditable && form.get('subDepartment')?.value
                    "
                  >
                    <app-dropdown
                      ngDefaultControl
                      formControlName="subDepartment"
                      [items]="subDepartmentItems"
                      [border]="'none'"
                      [isEditMode]="isEditable"
                    ></app-dropdown>
                    <app-error-field
                      [displayError]="
                        isFieldInvalid('subDepartment', form) &&
                        form.get('subDepartment')!.hasError('required')
                      "
                      [errorMessage]="'The field is required'"
                    ></app-error-field>
                  </div>
                </div>
              </div>
              <div class="row mb-3 general__item">
                <label
                  class="col-sm-3"
                  appMarkAsterisk
                  [formGroup]="form"
                  [controlName]="'firstProject'"
                  [touched]="form.get('firstProject')!.touched"
                  >Project name
                </label>
                <div class="col-sm-7 general_form_input">
                  <input
                    type="text"
                    class="input__basic"
                    placeholder=" "
                    formControlName="firstProject"
                  />
                  <app-error-field
                    [displayError]="
                      isFieldInvalid('firstProject', form) &&
                      form.get('firstProject')!.hasError('required')
                    "
                    [errorMessage]="'The field is required'"
                  ></app-error-field>
                  <app-error-field
                    [displayError]="
                      form.get('firstProject')!.hasError('maxlength')
                    "
                    [errorMessage]="'Max field length = 30'"
                  ></app-error-field>
                </div>
              </div>
              <div class="row mb-3 general__item" *ngIf="isDepartmentSelected">
                <label
                  class="col-sm-3"
                  appMarkAsterisk
                  [formGroup]="form"
                  [controlName]="'position'"
                  [touched]="form.get('position')!.touched"
                  >Position</label
                >
                <div class="col-sm-7">
                  <div
                    [class.custom-input-empty]="
                      isEditable && !form.get('position')?.value
                    "
                    [class.custom-input-filled]="
                      isEditable && form.get('position')?.value
                    "
                  >
                    <app-dropdown
                      [border]="'none'"
                      [items]="
                        isSubDepartment ? subPositionItems : positionItems
                      "
                      formControlName="position"
                      [countVisibleItems]="6"
                      [isEditMode]="isEditable"
                    ></app-dropdown>
                    <app-error-field
                      [displayError]="
                        isFieldInvalid('position', form) &&
                        form.get('position')!.hasError('required')
                      "
                      [errorMessage]="'The field is required'"
                    ></app-error-field>
                  </div>
                </div>
              </div>
              <div
                class="row mb-3 general__item"
                *ngIf="isPositionSelected && isDepartmentSelected"
              >
                <label class="col-sm-3">Level</label>
                <div class="col-sm-7">
                  <div
                    [class.custom-input-empty]="
                      isEditable && !form.get('level')?.value
                    "
                    [class.custom-input-filled]="
                      isEditable && form.get('level')?.value
                    "
                  >
                    <app-dropdown
                      [border]="'none'"
                      [items]="levelItems"
                      formControlName="level"
                      [isEditMode]="isEditable"
                    ></app-dropdown>
                  </div>
                </div>
              </div>
              <div
                class="row mb-3 general__item"
                *ngIf="
                  isSubDepartment &&
                  isDepartmentDelivery &&
                  !isSubDepartmentManagement
                "
              >
                <label
                  class="col-sm-3"
                  appMarkAsterisk
                  [formGroup]="form"
                  [controlName]="'pm'"
                  [touched]="form.get('pm')!.touched"
                  >Project manager
                </label>
                <div class="col-sm-7 general_form_input">
                  <div
                    [class.custom-input-empty]="
                      isEditable && !form.get('pm')?.value
                    "
                    [class.custom-input-filled]="
                      isEditable && form.get('pm')?.value
                    "
                  >
                    <app-dropdown
                      [border]="'none'"
                      [items]="pmItems"
                      formControlName="pm"
                      [isEditMode]="isEditable"
                    ></app-dropdown>
                  </div>
                  <app-error-field
                    [displayError]="
                      isFieldInvalid('pm', form) &&
                      form.get('pm')!.hasError('required')
                    "
                    [errorMessage]="'The field is required'"
                  ></app-error-field>
                </div>
              </div>
              <div
                class="row mb-3 general__item"
                *ngIf="
                  isSubDepartmentManagement ||
                  (isDepartmentSelected && !isDepartmentDelivery)
                "
              >
                <label
                  class="col-sm-3"
                  appMarkAsterisk
                  [formGroup]="form"
                  [controlName]="'lineManager'"
                  [touched]="form.get('lineManager')!.touched"
                  >Line Manager
                </label>
                <div class="col-sm-7 general_form_input">
                  <div
                    [class.custom-input-empty]="
                      isEditable && !form.get('lineManager')?.value
                    "
                    [class.custom-input-filled]="
                      isEditable && form.get('lineManager')?.value
                    "
                  >
                    <app-dropdown
                      [border]="'none'"
                      [items]="lineManagerItems"
                      formControlName="lineManager"
                      [isEditMode]="isEditable"
                    ></app-dropdown>
                  </div>
                  <app-error-field
                    [displayError]="
                      isFieldInvalid('lineManager', form) &&
                      form.get('lineManager')!.hasError('required')
                    "
                    [errorMessage]="'The field is required'"
                  ></app-error-field>
                </div>
              </div>
              <div class="row mb-3 general__item">
                <label
                  class="col-sm-3"
                  appMarkAsterisk
                  [formGroup]="form"
                  [controlName]="'unit'"
                  [touched]="form.get('unit')!.touched"
                  >Unit</label
                >
                <div class="col-sm-7 general_form_input">
                  <div
                    [class.custom-input-empty]="
                      isEditable && !form.get('unit')?.value
                    "
                    [class.custom-input-filled]="
                      isEditable && form.get('unit')?.value
                    "
                  >
                    <app-dropdown
                      [border]="'none'"
                      [items]="unitItems"
                      formControlName="unit"
                      [isEditMode]="isEditable"
                    ></app-dropdown>
                  </div>
                  <app-error-field
                    [displayError]="
                      isFieldInvalid('unit', form) &&
                      form.get('unit')!.hasError('required')
                    "
                    [errorMessage]="'The field is required'"
                  ></app-error-field>
                </div>
              </div>
              <div class="row mb-3 general__item" *ngIf="!isContractor">
                <label
                  class="col-sm-3"
                  appMarkAsterisk
                  [formGroup]="form"
                  [controlName]="'hr'"
                  [touched]="form.get('hr')!.touched"
                  >HR
                </label>
                <div class="col-sm-7 general_form_input">
                  <div
                    [class.custom-input-empty]="
                      isEditable && !form.get('hr')?.value
                    "
                    [class.custom-input-filled]="
                      isEditable && form.get('hr')?.value
                    "
                  >
                    <app-dropdown
                      [border]="'none'"
                      [items]="hrItems"
                      formControlName="hr"
                      [isEditMode]="isEditable"
                    ></app-dropdown>
                  </div>
                  <app-error-field
                    [displayError]="
                      isFieldInvalid('hr', form) &&
                      form.get('hr')!.hasError('required')
                    "
                    [errorMessage]="'The field is required'"
                  ></app-error-field>
                </div>
              </div>
              <div class="row mb-3 general__item">
                <label
                  class="col-sm-3"
                  appMarkAsterisk
                  [formGroup]="form"
                  [controlName]="'pe'"
                  [touched]="form.get('pe')!.touched"
                  >PE
                </label>
                <div class="col-sm-7 general_form_input">
                  <div
                    [class.custom-input-empty]="
                      isEditable && !form.get('pe')?.value
                    "
                    [class.custom-input-filled]="
                      isEditable && form.get('pe')?.value
                    "
                  >
                    <app-dropdown
                      [border]="'none'"
                      [items]="peItems"
                      formControlName="pe"
                      [isEditMode]="isEditable"
                    ></app-dropdown>
                  </div>
                  <app-error-field
                    [displayError]="
                      isFieldInvalid('pe', form) &&
                      form.get('pe')!.hasError('required')
                    "
                    [errorMessage]="'The field is required'"
                  ></app-error-field>
                </div>
              </div>
              <div class="row mb-3 general__item">
                <label
                  class="col-sm-3"
                  appMarkAsterisk
                  [formGroup]="form"
                  [controlName]="'os'"
                  [touched]="form.get('os')!.touched"
                  >OS
                </label>
                <div class="col-sm-7 general_form_input">
                  <div
                    [class.custom-input-empty]="
                      isEditable && !form.get('os')?.value
                    "
                    [class.custom-input-filled]="
                      isEditable && form.get('os')?.value
                    "
                  >
                    <app-dropdown
                      [border]="'none'"
                      [items]="osItems"
                      formControlName="os"
                      [isEditMode]="isEditable"
                    ></app-dropdown>
                  </div>
                  <app-error-field
                    [displayError]="
                      isFieldInvalid('os', form) &&
                      form.get('os')!.hasError('required')
                    "
                    [errorMessage]="'The field is required'"
                  ></app-error-field>
                </div>
              </div>
              <div class="row mb-3 general__item" *ngIf="isTechStack">
                <label
                  class="col-sm-3"
                  appMarkAsterisk
                  [formGroup]="form"
                  [controlName]="'techStack'"
                  [touched]="form.get('techStack')!.touched"
                  >Tech Stack
                </label>
                <div class="col-sm-7 general_form_input">
                  <div
                    [class.custom-input-empty]="
                      isEditable && !form.get('techStack')?.value
                    "
                    [class.custom-input-filled]="
                      isEditable && form.get('techStack')?.value
                    "
                  >
                    <app-dropdown
                      [border]="'none'"
                      [items]="techStackItems"
                      formControlName="techStack"
                      [isEditMode]="isEditable"
                    ></app-dropdown>
                  </div>
                  <app-error-field
                    [displayError]="
                      isFieldInvalid('techStack', form) &&
                      form.get('techStack')!.hasError('required')
                    "
                    [errorMessage]="'The field is required'"
                  ></app-error-field>
                </div>
              </div>
              <div class="row mb-3 general__item" *ngIf="isContractor">
                <label
                  class="col-sm-3"
                  appMarkAsterisk
                  [formGroup]="form"
                  [controlName]="'contractorWorkingHoursPerWeek'"
                  [touched]="form.get('contractorWorkingHoursPerWeek')!.touched"
                  >Amount of hours <br />
                  (per week)</label
                >
                <div class="col-sm-7 general_form_input">
                  <input
                    type="number"
                    class="input__basic"
                    placeholder=" "
                    formControlName="contractorWorkingHoursPerWeek"
                  />
                  <app-error-field
                    [displayError]="
                      isFieldInvalid('contractorWorkingHoursPerWeek', form) &&
                      form
                        .get('contractorWorkingHoursPerWeek')!
                        .hasError('required')
                    "
                    [errorMessage]="'The field is required'"
                  ></app-error-field>
                  <app-error-field
                    [displayError]="
                      form
                        .get('contractorWorkingHoursPerWeek')!
                        .hasError('max') ||
                      form.get('contractorWorkingHoursPerWeek')!.hasError('min')
                    "
                    [errorMessage]="'The value should be between 0 and 40'"
                  ></app-error-field>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="row mb-3">
                <label
                  class="col-sm-3 mr-0"
                  appMarkAsterisk
                  [formGroup]="form"
                  [controlName]="'country'"
                  [touched]="form.get('country')!.touched"
                  >Country
                </label>
                <div class="col-sm-7 general_form_input">
                  <div
                    [class.custom-input-empty]="
                      isEditable && !form.get('country')?.value
                    "
                    [class.custom-input-filled]="
                      isEditable && form.get('country')?.value
                    "
                  >
                    <app-dropdown
                      [border]="'none'"
                      [items]="countryItems"
                      formControlName="country"
                      [isEditMode]="isEditable"
                    ></app-dropdown>
                  </div>
                  <app-error-field
                    [displayError]="
                      isFieldInvalid('country', form) &&
                      form.get('country')!.hasError('required')
                    "
                    [errorMessage]="'The field is required'"
                  ></app-error-field>
                </div>
              </div>
              <div class="row mb-3">
                <label
                  class="col-sm-3 mr-0"
                  appMarkAsterisk
                  [formGroup]="form"
                  [controlName]="'city'"
                  [touched]="form.get('city')!.touched"
                  >City
                </label>
                <div class="col-sm-7 general_form_input">
                  <input
                    type="text"
                    class="input__basic"
                    placeholder=" "
                    formControlName="city"
                  />
                  <app-error-field
                    [displayError]="
                      isFieldInvalid('city', form) &&
                      form.get('city')!.hasError('required')
                    "
                    [errorMessage]="'The field is required'"
                  ></app-error-field>
                  <app-error-field
                    [displayError]="form.get('city')!.hasError('maxlength')"
                    [errorMessage]="'Max field length = 20'"
                  ></app-error-field>
                </div>
              </div>
              <div class="row mb-3">
                <label
                  class="col-sm-3 mr-0 personal-email-label"
                  appMarkAsterisk
                  [formGroup]="form"
                  [controlName]="'personalEmail'"
                  [touched]="form.get('personalEmail')!.touched"
                  >Personal email
                </label>
                <div class="col-sm-7 general_form_input">
                  <input
                    type="text"
                    class="input__basic"
                    placeholder=" "
                    formControlName="personalEmail"
                  />
                  <app-error-field
                    [displayError]="
                      form.get('personalEmail')!.hasError('maxlength')
                    "
                    [errorMessage]="'Max field length = 100'"
                  ></app-error-field>
                  <app-error-field
                    [displayError]="
                      form.get('personalEmail')!.hasError('pattern') &&
                      !form.get('personalEmail')!.hasError('maxlength')
                    "
                    [errorMessage]="'Please enter a valid email'"
                  ></app-error-field>
                  <app-error-field
                    [displayError]="
                      form.get('personalEmail')!.hasError('required') &&
                      form.get('personalEmail')!.touched
                    "
                    errorMessage="The field is required"
                  ></app-error-field>
                </div>
              </div>
              <div class="row mb-3">
                <app-messengers
                  (messengersChecked)="setPhoneNumber($event)"
                  [editMode]="isEditable"
                  [phoneData]="phoneNumbersComponentData"
                ></app-messengers>
              </div>
              <div class="row mb-3">
                <label
                  class="col-sm-10 mb-3"
                  appMarkAsterisk
                  [formGroup]="form"
                  [controlName]="'commentFromRecruiter'"
                  [touched]="form.get('commentFromRecruiter')!.touched"
                  >Comment</label
                >
                <div class="col-sm-10 general_form_input">
                  <div class="textarea__wrapper col-sm-12">
                    <textarea
                      type="textarea"
                      class="input__basic input__textarea width100"
                      placeholder=" "
                      formControlName="commentFromRecruiter"
                    ></textarea>
                    <app-error-field
                      [displayError]="
                        form.get('commentFromRecruiter')!.hasError('maxlength')
                      "
                      [errorMessage]="'Max field length = 1000 symbols'"
                    ></app-error-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        class="button button__save profile__button"
        (click)="save()"
        #saveButton
      >
        Save
      </button>
    </fieldset>
  </form>
</div>
